<template>
    <md-menu md-size="medium" md-align-trigger>

        <md-button @click.stop.prevent md-menu-trigger class="md-raised md-primary btn--narrow">
            <md-icon>more_vert</md-icon>
        </md-button>

        <md-menu-content>
            <md-menu-item v-if="showStatus('Downloaded')"
                @click="changeOrderStatus(statuses.sponsorship.DOWNLOADED_BY_PRINTER, statuses.signage.PARTY_APPROVED)">
                As downloaded</md-menu-item>
            <md-menu-item v-if="showStatus('Artwork Approved')"
                @click="changeOrderStatus(statuses.sponsorship.ARTWORK_APPROVED, statuses.signage.READY_TO_INSTALL)">
                As Artwork Approved</md-menu-item>
            <md-menu-item v-if="showStatus('Ready to Print')"
                @click="changeOrderStatus(statuses.sponsorship.READY_TO_PRINT, statuses.signage.READY_TO_PRINT)">
                As ready to print</md-menu-item>
            <md-menu-item v-if="showStatus('Preflight Problem')"
                @click="promptPrintProblemNote()">
                As Preflight Problem</md-menu-item>
        </md-menu-content>

        <md-dialog :md-active.sync="showPrintProblemDialog">
            <md-dialog-title>Preflight Problem Note</md-dialog-title>
            <md-dialog-content>
                <md-field>
                    <label>Describe the preflight problem</label>
                    <md-textarea v-model="printProblemNote" />
                </md-field>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="submitPrintProblemNote">Submit</md-button>
                <md-button @click="showPrintProblemDialog = false">Cancel</md-button>
            </md-dialog-actions>
        </md-dialog>

    </md-menu>
</template>

<script>
import { sponsorshipStatuses, signageStatuses } from '../../constants';

export default {
    name: 'OrderCardStatusesMenu',
    props: {
        order: {
            type: Object,
            required: true
        },
        allowedStatuses: {
            type: Array,
            default: null
        }
    },
    data: function() {
        return {
            statuses: {
                sponsorship: sponsorshipStatuses,
                signage: signageStatuses
            },
            showPrintProblemDialog: false,
            printProblemNote: ''
        }
    },
    methods: {
      showStatus(name) {
        if (!this.allowedStatuses) return true;
        return this.allowedStatuses.includes(name);
      },
      changeOrderStatus(sponsorshipStatus, signageStatus) {
        const isSponsorship = this.order.media_name === 'Sponsorship';
        const payload = isSponsorship
            ? { sponsorship_status: sponsorshipStatus }
            : { status_id: signageStatus };
        const url = isSponsorship
            ? `/sponsorships/${this.order.sponsorships_id}`
            : `/signage-orders/${this.order.id}`;
        this.$axios.put(url, payload)
            .then(() => this.$emit('statusUpdated'))
            .catch(console.log);
      },
      promptPrintProblemNote() {
        this.showPrintProblemDialog = true;
        this.printProblemNote = '';
      },
      submitPrintProblemNote() {
        this.showPrintProblemDialog = false;
        // Update status to Print Problem and send note
        const isSponsorship = this.order.media_name === 'Sponsorship';
        const payload = isSponsorship
            ? { sponsorship_status: this.statuses.sponsorship.PROBLEM, print_problem_note: this.printProblemNote }
            : { status_id: this.statuses.signage.PROBLEM, print_problem_note: this.printProblemNote };
        const url = isSponsorship
            ? `/sponsorships/${this.order.sponsorships_id}`
            : `/signage-orders/${this.order.id}`;
        this.$axios.put(url, payload)
            .then(() => this.$emit('statusUpdated'))
            .catch(console.log);
        // Emit note for parent to handle notification if needed
        this.$emit('printProblemNote', this.printProblemNote);
      }
    }
}
</script>


<style lang="scss" scoped>
.md-menu {
    margin-left: 5px;
    
    @include respond(xsmall) { 
        margin: 0;
    }
}
 /deep/  .btn--narrow {
    padding: 0;
    width: 40px;
    min-width: 40px;
    z-index: 0 !important;
    position: relative;

    @include respond(xsmall) { 
        width: 160px;
        margin: 8px 8px 0 0;
    }

    .md-ripple, .md-icon {
        z-index: 0 !important;
        position: relative;
    }
}
</style>